import React from 'react'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { type SxProps } from '@mui/material/styles'

import { Icon } from '@mxenabled/mx-icons'

import { Text } from '@mxenabled/mxui'

interface EmptyWidgetProps {
  icon: string
  iconColor?: string
  header: string
  onClick?: (buttonType: string) => void
  primaryButton?: string
  primaryButtonStartIcon?: string
  secondaryButton?: string
  subText: string
  sx?: SxProps
}

export const EmptyState: React.FC<EmptyWidgetProps> = ({
  icon,
  iconColor,
  header,
  onClick,
  primaryButton,
  primaryButtonStartIcon,
  secondaryButton,
  subText,
  sx,
}) => {
  return (
    <Stack
      sx={{
        alignItems: 'center',
        alignSelf: 'center',
        maxWidth: '100%',
        p: '12px 16px 24px 16px',
        ...sx,
      }}
    >
      <Icon name={icon} size={48} sx={{ color: iconColor }} />
      <Text
        className="empty-state-header"
        color="text.primary"
        sx={{ fontWeight: 600, mt: 16, textAlign: 'center' }}
        variant="body1"
      >
        {header}
      </Text>
      <Text
        className="empty-state-subtext"
        color="text.secondary"
        sx={{ fontWeight: 400, textAlign: 'center', width: 'calc(100% - 8px)' }}
        variant="subtitle2"
      >
        {subText}
      </Text>

      {(primaryButton || secondaryButton) && (
        <Stack
          className="buttons-footer"
          sx={{
            gap: 12,
            mt: 32,
          }}
        >
          {primaryButton && (
            <Button
              onClick={() => onClick?.('primary')}
              startIcon={
                primaryButtonStartIcon ? <Icon name={primaryButtonStartIcon} /> : undefined
              }
              sx={{ textWrap: 'nowrap' }}
              variant="contained"
            >
              {primaryButton}
            </Button>
          )}
          {secondaryButton && (
            <Button
              onClick={() => onClick?.('secondary')}
              sx={{ textWrap: 'nowrap' }}
              variant="text"
            >
              {secondaryButton}
            </Button>
          )}
        </Stack>
      )}
    </Stack>
  )
}
